import { RefObject } from 'react';

export const CART_QUERY_KEY = 'QUERY/CART_SESSION';
export const AVAILABLE_DELIVERY_COUNTRIES_QUERY_KEY = 'QUERY/AVAILABLE_DELIVERY_COUNTRIES_QUERY_KEY';
export const DEFAULT_EMAIL_ADDRESS = 'support@getjust.eu';
export const MAX_FAILURE_COUNT = 10;
export const MUTATION_LOGIN_KEY = 'MUTATION/LOGIN';
export const MUTATION_UPDATE_PROFILE = 'MUTATION/UPDATE_PROFILE';
export const MUTATION_ESTIMATED_SHIPPING = 'MUTATION/ESTIMATED_SHIPPING';
export const NO_SHIPPING_HANDLE = 'no-shipping';
export const ORDER_REQUEST_QUERY_KEY = 'QUERY/ORDER_REQUEST';
export const REFRESH_TOKEN_MUTATION_KEY = 'MUTATION/REFRESH_TOKEN';
export const REFS_MAP = new Map<string, RefObject<HTMLDivElement | null>>();
export const UPDATE_SOURCES_MUTATION_KEY = 'MUTATION/UPDATE_SOURCES';
export const USER_INFO_QUERY_KEY = 'QUERY/USER_INFO';
export const USER_LOCATION_DETECTION_QUERY_KEY = 'QUERY/USER_LOCATION_DETECTION';
// Debounce for the email-commit pipeline (typing → `trigger('email')` → `/login`
// network call). Was 1500 ms, which on top of a ~500–1500 ms `/login` round trip
// gave a perceived "long loading" of 2–3 s after the last keystroke. 400 ms is
// the typeahead sweet spot (Google Search uses ~200 ms; we're more conservative
// because /login sends an OTP — we don't want to fire on partial values like
// `jean@gmail.co`). Only affects email validation; no other field uses this.
export const VALIDATION_DEBOUNCE = 400;
export const LOGIN_URL = '/login';
export const REFRESH_URL = '/refresh';
export const USE_AUTH_LEGACY = true;
export const MOST_USED_COUNTRIES = ['FR', 'BE', 'CH', 'GB'];
export const MUTATION_CART_ADD_LINE_ITEMS_KEY = 'MUTATION/CART_ADD_LINE_ITEMS';
export const MUTATION_CART_UPDATE_LINE_ITEMS_KEY = 'MUTATION/UPDATE_LINE_ITEMS';
export const MUTATION_CART_DELETE_LINE_ITEMS_KEY = 'MUTATION/REMOVE_CHECKOUT_LINE_ITEMS';

export const ANALYTICS_IDENTIFIER_QUERY_KEY = 'QUERY/ANALYTICS_IDENTIFIER_QUERY_KEY';
